import { getApiEndpoint } from "../config/api.js";

export interface RelationshipEntity {
  id?: string;
  name: string;
  ticker?: string;
  relationship?: string;
  importance?: "critical" | "major" | "minor" | string;
  confidence?: number;
}

export interface RelationshipsResponse {
  suppliers: RelationshipEntity[];
  customers: RelationshipEntity[];
  competitors: RelationshipEntity[];
  lastUpdated: string;
}

export const relationshipsApi = {
  async getRelationships(profileId: string, opts?: { ttlSec?: number; force?: boolean }): Promise<RelationshipsResponse> {
    const base = getApiEndpoint();
    const url = new URL(
      `${base}/profile/${encodeURIComponent(profileId)}/relationships`
    );
    if (opts?.ttlSec) url.searchParams.set("ttlSec", String(opts.ttlSec));
    if (opts?.force) url.searchParams.set("force", String(opts.force));
    const res = await fetch(url.toString());
    if (!res.ok) {
      // Gracefully handle missing route or not found by returning empty sets
      if (res.status === 404) {
        return {
          suppliers: [],
          customers: [],
          competitors: [],
          lastUpdated: new Date().toISOString(),
        };
      }
      throw new Error(`Relationships failed: ${res.status}`);
    }
    const json = await res.json();
    return json.data as RelationshipsResponse;
  },
};
